import type { IAMRoleOut } from '@repo/api-codegen';
import { UserRole } from '@repo/common/enums/UserRole';

export type PricingDetailsType = 'viewers' | 'editors' | 'integrations';

interface GetPricingDetailsTypeParams {
	iamRoleId?: string | null;
	iamRoles?: IAMRoleOut[];
	legacyRole?: UserRole;
}

/**
 * Determines the pricing details type based on the user's role or IAM role
 * @param params Object containing iamRoleId, iamRoles, and role
 * @returns The pricing details type or undefined if no valid type can be determined
 */
export function getPricingDetailsType({
	iamRoleId,
	iamRoles,
	legacyRole,
}: GetPricingDetailsTypeParams): PricingDetailsType | undefined {
	if (iamRoleId && iamRoles) {
		const name = iamRoles.find((r) => r.id === iamRoleId)?.name.toLowerCase();
		if (name === 'viewer' || name === 'guest') {
			return 'viewers';
		} else {
			return 'editors';
		}
	} else if (legacyRole) {
		if (legacyRole === UserRole.VIEWER || legacyRole === UserRole.GUEST) {
			return 'viewers';
		} else {
			return 'editors';
		}
	}
	return undefined;
}
